import { loginAction } from '@mobile-dev/platform/common/redux/actions/LoginAction';
import { clearError, clearExistingUser } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';
import { Link, useHistory } from 'react-router-dom';
import NewBrandLogo from '../../assets/images/FreightSmith_LOGO_Final.png'
import '../../styles/floating-labels.css';
import ErrornDialog from '../Common/ErrorDialog/ErrorDialog';
import Loader from '../Common/Loader';
import LoaderButton from '../Common/LoaderButton';
import Auth from '@aws-amplify/auth';
import { Alert } from 'react-bootstrap';
import MobileInput from '../Common/MobileInput/MobileInput';
import { AppConstatnt } from '../../Utils/AppConstant';
import { getApplicationFlow, showAlert } from '../../Utils/Utility';
import { injectIntl } from 'react-intl';
import { checkforExistingUser } from '@mobile-dev/platform/common/redux/actions/AmplifyUserAction';
import { toast } from 'react-toastify';

const Login = ({ intl }) => {
    const [message, setMessage] = useState('');
    const [session, setSession] = useState('');
    const NOTSIGNIN = 'You are NOT logged in';
    const SIGNEDIN = 'You have logged in successfully';
    const SIGNEDOUT = 'You have logged out successfully';
    const WAITINGFOROTP = 'Enter OTP number';
    const VERIFYNUMBER = 'Verifying number (Country code +XX needed)';
    const dispatch = useDispatch();
    const [mobilenumber, setMobilenumber] = useState("");
    const history = useHistory();
    const [submitted, setSubmitted] = useState(false);
    const [errormessage, setErrormesasge] = useState(null);
    const loginData = useSelector(state => state.login);
    const errorStatus = useSelector(state => state.login.error);
    const [isValid, setValid] = useState(false);
    const location = useLocation();
    const { formatMessage } = intl;
    const existingUser = useSelector(state => state.amplifyUser.existingUser)
    const amplifyUser = useSelector(state => state.amplifyUser)
    useEffect(() => {
        dispatch(clearError());
        if (location?.state?.mobileNumber) {
            setMobilenumber(location.state.mobileNumber);
        }
    }, []);

    useEffect(() => {
        if (amplifyUser.error) {
            dispatch(clearExistingUser())
            showAlert(toast.TYPE.ERROR, `${formatMessage({ id: "app.error_content" })}`);
        }
    }, [amplifyUser.error]);

    useEffect(() => {
        if (existingUser) {
            setTimeout(() => {
                if (existingUser?.isExistingUser) {
                    initiateLogin()
                    dispatch(clearExistingUser())
                } else if (existingUser?.isExistingUser === false) {
                    const phone = `+${mobilenumber}`;
                    history.push({ pathname: '/signup', type: AppConstatnt.auth.SIGNUP, state: { mobileNumber: phone.replace('+', '') } });
                    dispatch(clearExistingUser())
                }
            }, 100);
        }
    }, [existingUser])

    const handlePhone = (phone) => {
        setMobilenumber(phone);
    }

    const handleValid = (value) => {
        setValid(value);
    }

    if (loginData.loading || amplifyUser.loading) return <Loader />
    if (loginData.captchaResponse && getApplicationFlow() === AppConstatnt.flow.DRIVER) {
        return <Redirect to='/' />;
    }

    if (loginData.session) {
        const captcha = {
            Question: loginData?.session?.challengeParam?.captchaQuestion
        }
        history.push({
            pathname: '/captcha', state: {
                captchaData: captcha,
                phone: mobilenumber
            }
        });
        return null;
    }
    else if (loginData.authPayload) {
        let phone = `+${mobilenumber}`;
        switch (loginData.authPayload.nextAction) {
            case AppConstatnt.auth.SIGNUP:
                history.push({ pathname: '/signup', type: AppConstatnt.auth.SIGNUP, state: { mobileNumber: phone.replace('+', '') } });
                return null;

            case AppConstatnt.auth.OTP:
                history.push({ pathname: '/Otp', state: { mobileNumber: phone, type: AppConstatnt.auth.OTP } });
                return null;

            case AppConstatnt.auth.SIGNUPCONFIRM:
                history.push({ pathname: '/Otp', state: { mobileNumber: phone, type: AppConstatnt.auth.SIGNUPCONFIRM } });
                return null;

            default:
                setErrormesasge(loginData.authPayload.error.message);
                break;
        }
    }


    const signIn = (e) => {
        e.preventDefault();
        checkforExistingCustomer()
        setSubmitted(true);
    };

    const initiateLogin = () => {
        dispatch(loginAction(mobilenumber));
    }

    const checkforExistingCustomer = () => {
        const data = {
            verificationType: "PHONE",
            phone_number: `+${mobilenumber}`
        }
        dispatch(checkforExistingUser(data))
    }

    return (

        <form className="form-signin"  >

            {message && <Alert>{message}</Alert>}
            <div className="card">

                <div className="card-header uc-blue"></div>

                <div className="card-header text-center bg-header">
                    <span className="text-dark-50 fa-lg">
                        <img className="img-fluid smith_logo" src={NewBrandLogo} alt="FrieghtSmith logo" />
                    </span>
                </div>
                <div className="card-body p-4">
                    <div className="text-center m-auto">
                        <h4 className="text-dark-50 text-center mt-0 font-weight-bold">{formatMessage({ id: "app.sign_in" })}</h4>
                        <p className="text-muted mb-4">{formatMessage({ id: "app.driver_sign_in_content" })}</p>
                    </div>

                    <MobileInput
                        phone={mobilenumber}
                        handlePhone={handlePhone}
                        handleValid={handleValid}
                    />
                    {errormessage && <div className="error mb-2" style={{ color: "#f97474" }}>{errormessage}</div>}
                    <LoaderButton
                        valid={isValid}
                        loading={loginData.loading}
                        onButtonClick={signIn}
                        name={formatMessage({ id: "app.driver_send_verification_code" })}
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12 text-center">
                    <p className="text-muted">{formatMessage({ id: "app.first_time_user" })}
                        <Link to='/Signup'>
                            <b className='text-orange ml-1'>{formatMessage({ id: "app.signup" })}</b>
                        </Link>
                    </p>
                </div>
            </div>
            <div className="row mt-3">
                <h6 className="text-dark-50 text-center mt-0 mb-4"><span className="remaining_amt"> App Version {process.env.REACT_APP_VERSION}</span></h6>
            </div>
            {errorStatus && <ErrornDialog
                error={errorStatus}
                open
            />}
        </form>

    )
}

export default injectIntl(Login);


